import VisibleComponent from '../VisibleComponent'
import Button from "../Button";
import Text from "../Text";
import './index.less'

// 当收回弹窗时，给class="reward-plus-dialog-container"元素增加"reward-close" class，展示弹窗去掉"reward-close" class
// 当点击弹窗跳转时，给class="reward-plus-dialog-container"元素增加"reward-loading" class
const template = `
    <div class="reward-plus-dialog-container">
        <div class="reward-plus-dialog-wrap">
            <div class="reward-left-box">
                <div class="reward-close-btn"></div>
                <div class="reward-content"></div>
            </div>
            <div class="reward-other">
               <div class="reward-image"></div>
               <span class="reward-multiple">×</span>
               <div class="reward-number"></div>
               <div class="reward-play-btn"></div>
             </div>
             <div class="reward-loading">
                <img src="https://hybird.rayjump.com/static/rp_loading_no_m.gif" alt="" class="play-icon-btn">
             </div>
        </div>
    </div>
`

/**
 * RewardPlusDialog类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class RewardDialog extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        this.rewardCloseBtnElem = this.element.querySelector('.reward-close-btn')
        this.rewardContentElem = this.element.querySelector('.reward-content')
        this.rewardOtherElem = this.element.querySelector('.reward-other')
        this.rewardImageElem = this.element.querySelector('.reward-image')
        this.rewardNumberElem = this.element.querySelector('.reward-number')
        this.rewardPlayBtnElem = this.element.querySelector('.reward-play-btn')
        this.render(options)
    }

    render(options) {
        const {
            buttonText = 'Play now',
            buttonType = 'cta',
            imageUrl,
            rewardContent,
            onCloseBtnClick,
            onButtonClick,
        } = options
        // 金币数量
        this.rewardNumberComp = new Text({
            text: rewardContent || 'Unknown',
            color:"#fff",
            line:"1",
        })
        this.rewardNumberComp.appendTo(this.rewardNumberElem)
        // 奖励信息
        if (rewardContent) {
            let rewardContentComp;
            rewardContentComp = new Text({
                text: rewardContent,
                color:"#fff",
                line:"1",
                textClassName:"reward-text"
            })
            rewardContentComp.appendTo(this.rewardContentElem)
        }
        // 金币图片
        if (imageUrl) {
            const imageComp = new Image();
            imageComp.src = imageUrl;
            imageComp.classList.add("reward-image");
            this.rewardImageElem.append(imageComp)
        }
        // 关闭按钮
        let closeBtnComp;
        closeBtnComp = new Button({
            type: "close",
            theme:"black",
            onClick: onCloseBtnClick,
        })
        closeBtnComp.appendTo(this.rewardCloseBtnElem)
        // 立即观看按钮
        this.playBtn = new Button({
            type: buttonType,
            text: buttonText,
            buttonClassName:"play-btn"
        })
        this.rewardPlayBtnElem.innerHTML = "";
        // 立即观看-播放按钮
        let playIconBtn = `<img src="https://hybird.rayjump.com/static/icon_play_green.png" alt="" class="play-icon-btn">`
        this.rewardPlayBtnElem.innerHTML = playIconBtn;
        this.playBtn.appendTo(this.rewardPlayBtnElem);
        // 下载事件绑定，可点击下载区域（金币图片，乘号，金币数量，播放按钮）
        this.rewardOtherElem.addEventListener("click",onButtonClick)
    }

    appendTo(target) {
        return new Promise(resolve => {
            if(target instanceof HTMLElement){
                target.appendChild(this.element)
            }else if(target instanceof VisibleComponent){
                target.element.appendChild(this.element)
            }
            resolve(this.show())
        })
    }

    initContent(){
        // 一定要在dialog show之后调用，获取真实宽度
        // 文案多少与播放按钮展示适配
        let rewardPlusDialogContainerWidth = this.element.clientWidth;
        let contentWidth = this.rewardContentElem.scrollWidth;
        console.log("###弹窗宽度：",rewardPlusDialogContainerWidth)
        console.log("###单行文案宽度：",contentWidth)
        console.log("###单行文案宽度占比：",contentWidth/rewardPlusDialogContainerWidth)
        console.log("###金币数量：",this.rewardNumber)
        console.log("###金币数量位数",String(this.rewardNumber).length)
        // 当文案scrollWidth 长度大于0.38，则由单行变为两行显示，且删除立即观看按钮，展示播放按钮
        if(contentWidth/rewardPlusDialogContainerWidth>0.38 || this.rewardNumber.toString().length>3){
            console.log("###文案宽度大于0.38或数字位数大于3位，展示播放按钮，删除文字按钮")
            this.element.querySelector('.play-icon-btn').style.display = "block"
        }else{
            this.playBtn.show();
        }
        // 变为两行展示，一定要在上面获取单行文字宽度之后再变为两行
        this.element.querySelector(".reward-text").querySelector("div").classList.add("line-clamp2");
    }

    setRewardNumber(rewardAmount) {
        this.rewardNumber = rewardAmount;
        // 改变金币数量
        this.rewardNumberComp.setInnerText(this.rewardNumber)
    }

    hasShow() {
        return this.hasShown
    }
}

export default RewardDialog